import { appConfig } from '../data/AppConfig';

export const AUTH_RETURN_TO_KEY = 'auth.returnTo';

let isRedirecting = false;
let isLoggingOut = false;

export function clearReturnPath(): void {
    sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
}

export function beginLogout(): void {
    isLoggingOut = true;
    clearReturnPath();
}

export function isExplicitLogout(): boolean {
    return isLoggingOut;
}

export function resetLogoutState(): void {
    isLoggingOut = false;
}

export function getCurrentReturnPath(): string {
    return (
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        window.location.search +
        window.location.hash
    );
}

/**
 * Pages that are themselves the way back in. Redirecting to sign-in from one of
 * these, or storing it as a return path, would loop.
 */
const AUTH_ROUTES = ['/sign-in', '/recover-password', '/reset-password', '/accept-invite'];

export function isAuthRoute(pathname: string = window.location.pathname): boolean {
    return AUTH_ROUTES.includes(pathname);
}

export function persistReturnPath(path?: string): void {
    if (isAuthRoute()) {
        return;
    }
    const returnPath = path ?? getCurrentReturnPath();
    if (!sessionStorage.getItem(AUTH_RETURN_TO_KEY)) {
        sessionStorage.setItem(AUTH_RETURN_TO_KEY, returnPath);
    }
}

export function peekReturnPath(): string | null {
    return sessionStorage.getItem(AUTH_RETURN_TO_KEY);
}

export function consumeReturnPath(): string | null {
    const path = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
    if (path) {
        sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
    }
    return path;
}

export function resolveLoginIntended(locationStateFrom?: string): string {
    return locationStateFrom || peekReturnPath() || appConfig.REACT_APP_FRONTEND_URL || '/';
}

export function redirectToSignIn(returnPath?: string): void {
    if (isRedirecting || isAuthRoute()) {
        return;
    }
    isRedirecting = true;
    persistReturnPath(returnPath);
    window.location.assign(`${appConfig.REACT_APP_FRONTEND_URL}/sign-in`);
}

export function shouldSkipAuthRedirect(url: string | undefined): boolean {
    if (!url) {
        return false;
    }
    return url.includes('api/me') || url.includes('/api/logout');
}
